var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle, _circle2, _circle3, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404NotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 306,
    viewBox: "0 0 475 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393.066 226.846C395.8 220.138 397.17 212.953 397.095 205.709C397.095 198.369 395.65 191.101 392.843 184.319C390.036 177.538 385.921 171.376 380.734 166.186C375.547 160.996 369.389 156.879 362.612 154.07C355.835 151.261 348.572 149.815 341.236 149.815C336.534 149.777 331.847 150.363 327.299 151.558C329.399 144.486 330.463 137.146 330.457 129.768C330.321 112.332 323.99 95.5134 312.595 82.3213C301.201 69.1292 285.488 60.4243 268.266 57.7641C251.045 55.104 233.44 58.6621 218.6 67.8019C203.761 76.9417 192.656 91.0668 187.272 107.65C182.918 103.082 177.68 99.4505 171.876 96.9777C166.072 94.5048 159.825 93.2425 153.517 93.2678C147.336 93.2535 141.213 94.4611 135.499 96.8214C129.786 99.1817 124.595 102.648 120.224 107.022C115.853 111.395 112.389 116.59 110.03 122.307C107.671 128.024 106.464 134.151 106.479 140.336C106.48 144.001 106.882 147.654 107.676 151.232C89.8837 154.509 73.9657 164.343 63.0649 178.791C52.1641 193.239 47.0726 211.251 48.7956 229.272C50.5186 247.292 58.9308 264.012 72.3716 276.13C85.8124 288.247 103.305 294.882 121.396 294.725H385.117C393.541 294.672 401.655 291.539 407.93 285.915C414.205 280.292 418.209 272.566 419.186 264.194C420.163 255.821 418.047 247.38 413.236 240.461C408.425 233.542 401.251 228.622 393.066 226.628V226.846Z",
    fill: "#E4999A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M409.869 230.078C412.603 223.371 413.972 216.185 413.898 208.941C413.898 201.601 412.453 194.333 409.646 187.552C406.838 180.77 402.724 174.609 397.537 169.419C392.35 164.228 386.192 160.111 379.415 157.302C372.638 154.493 365.375 153.048 358.039 153.048C353.337 153.009 348.65 153.595 344.102 154.791C346.202 147.718 347.266 140.378 347.259 133C347.124 115.564 340.792 98.7458 329.398 85.5537C318.004 72.3616 302.29 63.6567 285.069 60.9966C267.848 58.3364 250.243 61.8945 235.403 71.0343C220.564 80.1741 209.459 94.2992 204.075 110.882C199.721 106.314 194.482 102.683 188.679 100.21C182.875 97.7373 176.628 96.4749 170.32 96.5003C164.139 96.4859 158.016 97.6935 152.302 100.054C146.589 102.414 141.397 105.881 137.027 110.254C132.656 114.628 129.191 119.822 126.833 125.539C124.474 131.256 123.267 137.383 123.281 143.569C123.283 147.233 123.685 150.887 124.479 154.464C106.686 157.742 90.7685 167.575 79.8677 182.023C68.9668 196.471 63.8753 214.483 65.5983 232.504C67.3213 250.525 75.7336 267.244 89.1744 279.362C102.615 291.48 120.108 298.115 138.199 297.957H401.92C410.344 297.905 418.458 294.771 424.733 289.148C431.008 283.524 435.012 275.798 435.989 267.426C436.966 259.054 434.85 250.613 430.039 243.693C425.228 236.774 418.054 231.854 409.869 229.861V230.078Z",
    fill: "#C63031"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.754,
    y: 60.2207,
    width: 242.844,
    height: 242.844,
    rx: 23,
    fill: "white",
    stroke: "#C63031",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.754 68.2207C113.754 62.6979 118.231 58.2207 123.754 58.2207H350.598C356.121 58.2207 360.598 62.6979 360.598 68.2207V84.5692H113.754V68.2207Z",
    fill: "#C63031"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.754 53.8066C113.754 45.5224 120.47 38.8066 128.754 38.8066H193.054C201.338 38.8066 208.054 45.5224 208.054 53.8066V65.1551H113.754V53.8066Z",
    fill: "#C63031"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.092 127.908L178.933 149.75",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.934 127.908L157.092 149.75",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.422 127.908L317.263 149.75",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.264 127.908L295.422 149.75",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M433.566 126.627L451.407 144.468",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M451.408 126.627L433.568 144.468",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M252.602 233.979V213.804L268.75 215.446L284.438 219.155V233.979C284.438 242.771 277.311 249.898 268.52 249.898C259.728 249.898 252.602 242.771 252.602 233.979Z",
    fill: "#FF7979",
    stroke: "#C63031",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.57 226.241C193.261 215.609 253.4 200.725 304.433 226.241",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.851 233.325C268.851 229.942 268.851 222.575 268.851 215.238",
    stroke: "#C63031",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 15.8333,
    cy: 134.13,
    r: 11.8333,
    stroke: "#C63031",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 464.66,
    cy: 236.563,
    r: 6.34014,
    stroke: "#C63031",
    strokeWidth: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 360.613,
    cy: 56.9019,
    r: 14.0952,
    stroke: "#C63031",
    strokeWidth: 8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43555 270.787L21.3836 288.735",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3848 270.787L3.4367 288.735",
    stroke: "#C63031",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2891 4L74.4611 33.1721",
    stroke: "#C63031",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4629 4L45.2908 33.1721",
    stroke: "#C63031",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404NotFound);
export default __webpack_public_path__ + "static/media/404_not_found.ed31514e8cb98055c8a1183f48d6f713.svg";
export { ForwardRef as ReactComponent };